import React from "react";
import { Link } from "react-router-dom";
import { formatNGN } from "@/lib/api";
import { BRAND_ASSETS } from "@/lib/brand";

function BrandMark() {
  return (
    <img
      src={BRAND_ASSETS.logo}
      alt="SunPress Solar"
      style={{ height: 26, width: "auto", objectFit: "contain" }}
    />
  );
}

export default function ProductCard({ product }) {
  const available = product.status === "available";
  return (
    <Link
      to={available ? `/products/${product.sku}` : "/products"}
      data-testid={`product-card-${product.sku}`}
      className="product-card group block"
    >
      <div className="relative overflow-hidden glossy" style={{ aspectRatio: "4/5" }}>
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute bottom-3 right-3 px-2 py-1 rounded-full backdrop-blur-md" style={{ background: "rgba(255,255,255,0.92)" }}>
          <BrandMark />
        </div>
        {!available && (
          <span className="coming-tag" data-testid={`coming-soon-${product.sku}`}>
            Coming soon
          </span>
        )}
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-serif text-2xl leading-tight" style={{ color: "var(--ink)" }}>{product.name}</h3>
          <p className="text-sm mt-1" style={{ color: "var(--ink-soft)" }}>{product.tagline}</p>
        </div>
        <div className="text-right">
          {available ? (
            <div>
              {product.compare_at_ngn > product.price_ngn && (
                <div className="text-xs font-mono line-through" data-testid={`card-compare-price-${product.sku}`} style={{ color: "var(--ink-muted)" }}>
                  {formatNGN(product.compare_at_ngn)}
                </div>
              )}
              <div className="text-lg font-medium font-mono" style={{ color: "var(--ink)" }}>{formatNGN(product.price_ngn)}</div>
            </div>
          ) : (
            <div className="text-xs uppercase tracking-widest" style={{ color: "var(--ink-muted)" }}>Soon</div>
          )}
        </div>
      </div>
    </Link>
  );
}
